const A = "/brand";

export function TheShift() {
  return (
    <section
      data-testid="the-shift-section"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #FAFAF8 0%, #F8F7F5 50%, #FAFAF8 100%)" }}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 items-stretch gap-0">

        {/* LEFT: copy — padded, vertically centered */}
        <div className="px-6 md:px-10 pt-14 md:pt-20 pb-12 md:pb-20 flex items-center order-1">
          <div className="w-full max-w-md reveal">
            <div className="space-y-6">
              <p className="font-display text-3xl md:text-4xl text-[#1C1917] leading-snug">
                There's a moment in certain rooms.
              </p>
              <div className="space-y-4 text-xl text-[#57534E] leading-relaxed">
                <p>
                  You can't force it.
                  <br />
                  You can't script it.
                </p>
                <p>
                  It's when people stop nodding politely
                  <br />
                  and start recognizing themselves in what's being said.
                </p>
                <p>
                  Shoulders soften.
                  <br />
                  Pens move.
                  <br />
                  The air changes.
                </p>
              </div>
              <p className="font-display text-3xl md:text-4xl text-[#159E9A] leading-snug pt-2">
                That's the shift.
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT: image — bleeds to right viewport edge */}
        <div className="relative overflow-hidden order-2" style={{ minHeight: "480px" }}>
          <div
            className="absolute inset-x-0 top-0 h-28 z-[1]"
            style={{ background: "linear-gradient(to bottom, #F8F7F5 0%, transparent 100%)" }}
          />
          <div
            className="absolute inset-y-0 left-0 w-28 lg:w-48 z-[1]"
            style={{ background: "linear-gradient(to right, #F8F7F5 0%, transparent 100%)" }}
          />
          <div
            className="absolute inset-x-0 bottom-0 h-40 z-[1]"
            style={{ background: "linear-gradient(to top, #FAFAF8 0%, transparent 100%)" }}
          />
          <img
            src={`${A}/blueprint4joy-speaking-facilitating-roundtables.jpg`}
            alt="Lara seated at a round table with workshop participants writing and engaging."
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover reveal"
            style={{ objectPosition: "56% 0%", transform: "scale(1.10)", transformOrigin: "56% 30%" }}
          />
        </div>

      </div>
    </section>
  );
}
